import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr'; // the locale you want
import moment from 'moment';
registerLocale('fr', fr); // register it with the name you want

const errorStyle = {
	color: '#dc0000',
	fontSize: '0.7em',
};

const label = {
	fontSize: '0.8em',
	marginTop: 5,
	marginLeft: 2,
};

const styles = {
	crossRequired: {
		color: '#c5190e',
		fontSize: '1em',
		position: 'relative',
		bottom: 1,
		left: 3,
	},
};

const CustomTimePickerComponent = ({
	field: { name, value, onBlur },
	form: { touched, errors, setFieldValue },
	customOnChange,
	min,
	max,
	placeholder = '',
	...props
}) => {
	return (
		<div>
			<div style={label}>
				{props.customlabel}
				{props.required && <span style={styles.crossRequired}>*</span>}
			</div>

			<DatePicker
				{...props}
				shouldCloseOnSelect={false}
				name={name}
				value={
					(value &&
						moment({
							hour: value.substring(0, 2),
							minute: value.slice(-2),
						}).format(process.env.REACT_APP_TIME_DISPLAY_FORMAT)) ||
					null
				}
				onChange={
					customOnChange ??
					((val) => {
						setFieldValue(name, moment(val).format('HH:mm'));
					})
				}
				onBlur={onBlur}
				selected={
					(value &&
						moment({
							hour: value.substring(0, 2),
							minute: value.slice(-2),
						}).toDate()) ||
					null
				}
				minTime={min}
				maxTime={max}
				placeholderText={placeholder}
				className={
					touched[name] && errors[name] ? 'custom-input custom-input-error' : 'custom-input'
				}
				locale='fr'
				showTimeSelect
				showTimeSelectOnly
				timeIntervals={15}
				timeCaption='Time'
			/>
			{touched[name] && errors[name] && (
				<div style={errorStyle}>{errors[name]}</div>
			)}
		</div>
	);
};

export default CustomTimePickerComponent;
